export default "__VITE_ASSET__DwDnRQLm__"